module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/014-d16f3adf35f766ed4b2e6d93e5f2dedf.jpg";